import type { FaireProductEntity } from "../../entity_types/product";

export const p_xw3kwajszj: FaireProductEntity = {
  token: "p_xw3kwajszj",
  type: "product",
  name: "Ballerina Birthday Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl: "https://cdn.faire.com/fastly/08c8bae379f75252941b0b4a8f9e362b8f6763a490eb0737a311bc68cc92549d.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6c0fc8bce598e33a699e4d90597e45b59f11b998a90b5151d98b6a33374a5c08.png",
    "https://cdn.faire.com/fastly/1d3529a117e15e8cc27f2a99c887cbbf9a49be86cafd60bf45ea8164faf18bad.png"
  ],
  priceDollars: 3,
  description: "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:37:08.122Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
